"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = (0, _makeStyles.default)(function (theme) {
  return {
    root: {
      display: "block",
      position: "relative",
      width: "100%"
    },
    image: {
      "& img": {
        left: 0,
        position: "absolute",
        top: 0,
        width: "100%",
        height: "100%"
      }
    },
    content: _defineProperty({
      alignItems: "flex-start",
      color: "#FFFFFF",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-end",
      margin: "0 auto",
      maxWidth: 1872,
      minHeight: 650,
      padding: theme.spacing(3),
      position: "relative",
      textAlign: "left",
      width: "100%",
      zIndex: 1
    }, theme.breakpoints.up("md"), {
      minHeight: 650,
      paddingBottom: theme.spacing(10),
      paddingLeft: theme.spacing(10),
      paddingRight: theme.spacing(10)
    }),
    wrapper: _defineProperty({
      background: "rgba(0, 0, 0, 0.5)",
      maxWidth: 632,
      padding: theme.spacing(4, 3)
    }, theme.breakpoints.up("md"), {
      padding: theme.spacing(5, 6)
    }),
    title: {
      marginBottom: theme.spacing(4)
    }
  };
});
var _default = styles;
exports.default = _default;